import {NgModule} from "@angular/core";
import {BeslutningRedigerDialogKomponentAvhengigheter} from "web-ng2/moduler/beslutning/modale/beslutning-rediger-dialog/beslutning-rediger-dialog";
import {BeslutningOpprettDialogKomponentAvhengigheter} from "web-ng2/moduler/beslutning/modale/beslutning-opprett-dialog/beslutning-opprett-dialog";
import {BeslutningListevisningKompaktKomponentAvhengigheter} from "web-ng2/moduler/beslutning/komponenter/beslutning-listevisning-kompakt/beslutning-listevisning-kompakt";
import {BeslutninglisteKompaktKomponentAvhengigheter} from "web-ng2/moduler/beslutning/komponenter/beslutningliste-kompakt/beslutningliste-kompakt";

@NgModule({
    providers: [
        BeslutningRedigerDialogKomponentAvhengigheter,
        BeslutningOpprettDialogKomponentAvhengigheter,
        BeslutningListevisningKompaktKomponentAvhengigheter,
        BeslutninglisteKompaktKomponentAvhengigheter
    ]
})
export class BeslutningModul {

}
